import * as ActionTypes from '../actions/types';
import xs from 'xstream';
import * as actions from '../actions';
import GENERAL_FUNCTIONS from '../utils/functions/functions';

const REQUEST_CLAIM_REVIEW_VALIDITY = 'requestClaimReviewValidity';
const REQUEST_CLAIM_REVIEW_DETAILS = 'requestClaimReviewDetails';
const REQUEST_ACCEPT_CLAIM_REVIEW = 'requestAcceptClaimReview';
const REQUEST_REJECTION_FORM_CLAIM_REVIEW = 'requestRejectionFormClaimReview';
const REQUEST_REJECT_CLAIM_REVIEW_WITH_REASON =
    'requestRejectClaimReviewWithReason';

export function requestClaimReviewValidity(sources) {
    const request$ = sources.ACTION.filter(
        action => action.type === ActionTypes.FETCH_CLAIM_REVIEW_VALIDITY,
    ).map(action => ({
        url: `${GENERAL_FUNCTIONS.getBaseURL()}api/action/reviewClaim/${action.payload.claimApplicationId}/${action.payload.randomId}`,
        category: REQUEST_CLAIM_REVIEW_VALIDITY,
        method: 'GET',
    }));

    let httpResponse$ = sources.HTTP.select(REQUEST_CLAIM_REVIEW_VALIDITY)
        .map(response => response.replaceError(err => xs.of(err)))
        .flatten()
        .map(response =>
            response.status === 200
                ? actions.fetchClaimReviewValiditySuccess(response)
                : actions.fetchClaimReviewValidityFailed(response),
        );

    return {
        ACTION: httpResponse$,
        HTTP: request$,
    };
}

export function requestClaimReviewDetails(sources) {
    const request$ = sources.ACTION.filter(
        action => action.type === ActionTypes.FETCH_CLAIM_REVIEW_DETAILS,
    ).map(action => ({
        url: `${GENERAL_FUNCTIONS.getBaseURL()}api/action/reviewClaim/${action.payload.ClaimApplicationId}/${action.payload.RandomId}/claimDetails`,
        category: REQUEST_CLAIM_REVIEW_DETAILS,
        method: 'POST',
        send: action.payload,
    }));

    let httpResponse$ = sources.HTTP.select(REQUEST_CLAIM_REVIEW_DETAILS)
        .map(response => response.replaceError(err => xs.of(err)))
        .flatten()
        .map(response =>
            response.status === 200
                ? actions.fetchClaimReviewDetailsSuccess(response)
                : actions.fetchClaimReviewDetailsFailed(response),
        );

    return {
        ACTION: httpResponse$,
        HTTP: request$,
    };
}

export function requestAcceptClaimReview(sources) {
    const request$ = sources.ACTION.filter(
        action => action.type === ActionTypes.ACCEPT_CLAIM_REVIEW,
    ).map(action => ({
        url: `${GENERAL_FUNCTIONS.getBaseURL()}api/action/reviewClaim/${action.payload.ClaimApplicationId}/${action.payload.RandomId}/accept`,
        category: REQUEST_ACCEPT_CLAIM_REVIEW,
        method: 'PUT',
        send: action.payload,
    }));

    let httpResponse$ = sources.HTTP.select(REQUEST_ACCEPT_CLAIM_REVIEW)
        .map(response => response.replaceError(err => xs.of(err)))
        .flatten()
        .map(response =>
            response.status === 200
                ? actions.acceptClaimReviewSuccess(response)
                : actions.acceptClaimReviewFailed(response),
        );

    return {
        ACTION: httpResponse$,
        HTTP: request$,
    };
}

export function requestRejectionFormClaimReview(sources) {
    const request$ = sources.ACTION.filter(
        action => action.type === ActionTypes.FETCH_REJECTION_FORM_CLAIM_REVIEW,
    ).map(action => ({
        url: `${GENERAL_FUNCTIONS.getBaseURL()}api/action/reviewClaim/${action.payload.ClaimApplicationId}/${action.payload.RandomId}/rejectForm?languageId=${action.payload.LanguageId}`,
        category: REQUEST_REJECTION_FORM_CLAIM_REVIEW,
        method: 'GET',
    }));

    let httpResponse$ = sources.HTTP.select(REQUEST_REJECTION_FORM_CLAIM_REVIEW)
        .map(response => response.replaceError(err => xs.of(err)))
        .flatten()
        .map(response =>
            response.status === 200
                ? actions.fetchRejectionFormClaimReviewSuccess(response)
                : actions.fetchRejectionFormClaimReviewFailed(response),
        );

    return {
        ACTION: httpResponse$,
        HTTP: request$,
    };
}

export function requestRejectClaimReviewWithReason(sources) {
    const request$ = sources.ACTION.filter(
        action => action.type === ActionTypes.REJECT_CLAIM_REVIEW_WITH_REASON,
    ).map(action => ({
        url: `${GENERAL_FUNCTIONS.getBaseURL()}api/action/reviewClaim/${action.payload.ClaimApplicationId}/${action.payload.RandomId}/reject`,
        category: REQUEST_REJECT_CLAIM_REVIEW_WITH_REASON,
        method: 'PUT',
        send: action.payload,
    }));

    let httpResponse$ = sources.HTTP.select(
        REQUEST_REJECT_CLAIM_REVIEW_WITH_REASON,
    )
        .map(response => response.replaceError(err => xs.of(err)))
        .flatten()
        .map(response =>
            response.status === 200
                ? actions.rejectClaimReviewWithReasonSuccess(response)
                : actions.rejectClaimReviewWithReasonFailed(response),
        );

    return {
        ACTION: httpResponse$,
        HTTP: request$,
    };
}
